<div class="client-search-wrapper">
  <p-iftalabel>

    <p-autoComplete
      [(ngModel)]="query"
      [suggestions]="results()"
      [dropdown]="true"
      [appendTo]="'body'"
      (completeMethod)="searchClients($event)"
      (onSelect)="onClientSelect($event)"
      [autoHighlight]="true"
      [fluid]="true"
      [emptyMessage]="emptyMessage"
      inputId="clientSearch"
      >

      <ng-template let-item pTemplate="item">
        @if (item.type === 'session') {
          <bn-client-info
            [session]="item.value"
            />
        } @else {
          <bn-client-prototype-search-result [data]="item.value" [compact]="true" />
        }
      </ng-template>
      <ng-template pTemplate="footer">
        <div class="px-3 py-2 text-sm text-surface-500 flex items-center gap-2">
          @if (loadingFromApi()) {
            <i
              class="pi pi-spin pi-spinner text-surface-400"
            ></i>
          }
          @if (loadingFromApi()) {
            <span>Searching remote clients...</span>
          }
          @if (!loadingFromApi() && results().length === 0) {
            <span>No matches found</span>
          }
        </div>
      </ng-template>
    </p-autoComplete>
    <label for="clientSearch">Search Clients</label>
  </p-iftalabel>
</div>
